import * as React from 'react'

const SvgWritingIcon = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8337 4L5.41851 5.08303C5.11601 5.14353 4.96476 5.17377 4.8416 5.24733C4.73271 5.31236 4.6401 5.40139 4.57082 5.50763C4.49246 5.6278 4.45627 5.77774 4.38389 6.07761L1.66699 17.3333M1.66699 17.3333L12.9227 14.6164C13.2226 14.5441 13.3725 14.5079 13.4927 14.4295C13.5989 14.3602 13.688 14.2676 13.753 14.1587C13.8265 14.0356 13.8568 13.8843 13.9173 13.5818L15.0003 8.16666M1.66699 17.3333L7.98866 11.0117M17.3908 5.55719L13.4431 1.60947C13.1131 1.27946 12.9481 1.11445 12.7578 1.05263C12.5905 0.998245 12.4102 0.998245 12.2428 1.05263C12.0525 1.11445 11.8875 1.27946 11.5575 1.60947L10.9431 2.22385C10.6131 2.55387 10.4481 2.71888 10.3863 2.90915C10.3319 3.07652 10.3319 3.25681 10.3863 3.42418C10.4481 3.61445 10.6131 3.77946 10.9431 4.10947L14.8908 8.05719C15.2209 8.3872 15.3859 8.55221 15.5761 8.61403C15.7435 8.66841 15.9238 8.66841 16.0912 8.61403C16.2814 8.55221 16.4465 8.3872 16.7765 8.05719L17.3908 7.44281C17.7209 7.11279 17.8859 6.94778 17.9477 6.75751C18.0021 6.59014 18.0021 6.40985 17.9477 6.24248C17.8859 6.05221 17.7209 5.8872 17.3908 5.55719ZM9.16699 8.16666C10.0875 8.16666 10.8337 8.91286 10.8337 9.83333C10.8337 10.7538 10.0875 11.5 9.16699 11.5C8.24652 11.5 7.50032 10.7538 7.50032 9.83333C7.50032 8.91286 8.24652 8.16666 9.16699 8.16666Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgWritingIcon
